import { render, staticRenderFns } from "./filetesting.vue?vue&type=template&id=15dd27e4&"
import script from "./filetesting.vue?vue&type=script&lang=js&"
export * from "./filetesting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports